import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { SettingsForm } from "~/components/company/settings-form";
import { Page, PageHeader } from "~/components/shell/page";
import { meQueryOptions } from "~/lib/api/me";

export const Route = createFileRoute("/_authenticated/instellingen")({
  component: SettingsPage,
});

function SettingsPage() {
  const { data: partner } = useSuspenseQuery(meQueryOptions());

  return (
    <Page>
      <PageHeader title="Instellingen">Bedrijfsgegevens en uitbetaling.</PageHeader>
      <SettingsForm partner={partner} />
    </Page>
  );
}
